<app-button-close
    [overrideExtra]="{queryParams: {fromAllocationExecution: 1}}"
    appNavigateBack>
</app-button-close>

<div class="execution-content" [kalLoading]="loading" [appProgressOverlay]="['list']">

    <kal-card *ngIf="executionModel"
              [formGroup]="form">

        <kal-card-header>

            <kal-card-title>
                {{ allocation?.label }}
            </kal-card-title>

            <div class="kal-card-under-title">
                {{ allocation?.Description}} - {{ allocation?.Montant}}
            </div>

        </kal-card-header>

        <kal-card-content>

            <div class="gup-C-flexGroup -row -justifyBetween -alignStart"
                 [formGroup]="filtersForm">

                <div class="gup-C-flexGroup__item -demi">

                    <kal-form-field>
                        <kal-select label="Site"
                                    formControlName="Site">
                            <kal-option [value]="null">Tous</kal-option>
                            <kal-option *ngFor="let site of sitesList"
                                        [value]="site.IdSite">
                                {{ site.NomSite }}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>

                </div>

                <div class="gup-C-flexGroup__item -demi">

                    <kal-form-field>
                        <kal-select label="Contrat"
                                    formControlName="Contrat">
                            <kal-option [value]="null">Tous</kal-option>
                            <kal-option *ngFor="let contract of contractsList"
                                        [value]="contract.Id">
                                {{ contract.Valeur }}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>

                </div>

            </div>

            <kal-table
                [columns]="columns"
                [dataSource]="displayedBeneficiariesList"
                [displayedColumns]="displayedColumns"
                [selection]="selection"
                [virtualItemSize]="30"
                virtual
                virtualViewPortHeight="calc(100% - 188px)">

                <tr *kalHeaderRowDef kal-header-row></tr>

                <ng-container kalColumn="NomBenefOD">
                    <td *kalBodyCell="let element">
                        {{ getBeneficiaryName(element.NomBenefOD, element.PrenomBenefOD, element.MatriculeBenefOD) }}
                    </td>
                </ng-container>

                <ng-container kalColumn="NomBenefCible">
                    <td *kalBodyCell="let element">
                        {{ getBeneficiaryName(element.NomBenefCible, element.PrenomBenefCible, element.MatriculeBenefCible) }}
                    </td>
                </ng-container>

                <ng-container kalColumn="TypeBenef">
                    <td *kalBodyCell="let element">
                        {{ getBeneficiaryType(element) }}
                    </td>
                </ng-container>

                <ng-container kalColumn="QuantiteControl">
                    <td *kalBodyCell="let element">
                        <kal-input (click)="stopPropagation($event)"
                                   [formControl]="element.QuantiteControl">
                        </kal-input>
                    </td>
                </ng-container>

                <ng-container kalColumn="MontantAttribution">
                    <td *kalBodyCell="let element">
                        {{ element.MontantAttribution | currency:'EUR' }}
                    </td>
                </ng-container>

                <ng-container kalColumn="Site">
                    <td *kalBodyCell="let element">{{ element.Site?.Valeur }}</td>
                </ng-container>

                <ng-container kalColumn="TypeContrat">
                    <td *kalBodyCell="let element">
                        {{ element.TypeContrat?.Valeur }}
                    </td>
                </ng-container>

            </kal-table>

            <div class="resume">

                <div>
                    <span>Nombre d'ouvrants droits : </span>
                    <span>{{ countBeneficaries('OD') }}</span>
                </div>

                <ng-container  *ngIf="allocation?.isNominatif">

                    <div>
                        <span>Nombre de conjoints : </span>
                        <span>{{ countBeneficaries('CON') }}</span>
                    </div>

                    <div>
                        <span>Nombre d'enfants : </span>
                        <span>{{ countBeneficaries('ENF') }}</span>
                    </div>

                    <div>
                        <span>Nombre d'externes : </span>
                        <span>{{ countBeneficaries('EXT') }}</span>
                    </div>

                </ng-container>

                <div *ngIf="code === 'ART' else totalAmountTemplate">
                    <span>Quantité totale : </span>
                    <span>{{ beneficiariesODAmount }}</span>
                </div>

                <ng-template #totalAmountTemplate>
                    <div>
                        <span>Montant total : </span>
                        <span>{{ beneficiariesODAmount | currency:'EUR' }}</span>
                    </div>
                </ng-template>

            </div>

            <div class="date">

                <kal-form-field class="gup-C-formFieldSize--date">
                    <kal-datepicker formControlName="DateAttribution"
                                    label="Date mouvements">
                    </kal-datepicker>
                </kal-form-field>

                <kal-form-field>
                    <kal-input formControlName="Libelle"
                               label="Libellé des commandes liées à l'attribution">
                    </kal-input>
                </kal-form-field>

            </div>

            <p *ngIf="dateLabel"
               class="gup-U-color--red">
                {{ dateLabel }}
            </p>

            <app-shared-comment-edit formControlName="Comment">
            </app-shared-comment-edit>

        </kal-card-content>

        <kal-card-actions>

            <kal-button (click)="executeAllocation()"
                        [disabled]="form.invalid || loading || (selectedBeneficiariesList | arrayEmpty)"
                        kalTheme="primary">
                {{libelleExecution}}
            </kal-button>

            <kal-button (click)="cancel()"
                        [disabled]="loading"
                        kalTheme="secondary">
                Annuler
            </kal-button>

            <kal-button (click)="export()"
                        [disabled]="loading || (selectedBeneficiariesList | arrayEmpty)"
                        kalTheme="tertiary">
                Exporter
            </kal-button>

        </kal-card-actions>

    </kal-card>

</div>
